import { render } from "./cabinet.layout.vue?vue&type=template&id=5f44eecb"
import script from "./cabinet.layout.vue?vue&type=script&lang=js"
export * from "./cabinet.layout.vue?vue&type=script&lang=js"

import "./cabinet.layout.vue?vue&type=style&index=0&id=5f44eecb&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__